import clsx from 'clsx';
import { Check, X } from 'lucide-react';
import type { Draft, MatchingQ } from '../types';
import styles from '../QuizView.module.css';

type Props = {
  question: MatchingQ;
  draft: Extract<Draft, { format: 'matching' }>;
  onChange: (d: Extract<Draft, { format: 'matching' }>) => void;
  disabled: boolean;
  showFeedback: boolean;
};

export function Matching({ question, draft, onChange, disabled, showFeedback }: Props) {
  const set = (leftSlot: number, rightSlot: number | null) => {
    const next = draft.matches.slice();
    next[leftSlot] = rightSlot;
    onChange({ ...draft, matches: next });
  };

  return (
    <div className={styles.matching}>
      {question.instruction && (
        <p className={styles.qInstruction}>{question.instruction}</p>
      )}

      <ol className={styles.matchList}>
        {draft.leftOrder.map((pairIdx, leftSlot) => {
          const picked = draft.matches[leftSlot];
          const correct =
            showFeedback &&
            picked !== null &&
            draft.rightOrder[picked] === pairIdx;
          const wrong = showFeedback && picked !== null && !correct;
          return (
            <li
              key={leftSlot}
              className={clsx(
                styles.matchRow,
                correct && styles.slotCorrect,
                wrong && styles.slotWrong
              )}
            >
              <span className={styles.matchLeft}>{question.pairs[pairIdx].item}</span>
              <div className={styles.matchPicker}>
                <select
                  value={picked ?? ''}
                  onChange={(e) =>
                    set(leftSlot, e.target.value === '' ? null : Number(e.target.value))
                  }
                  disabled={disabled}
                  className={clsx(
                    styles.matchSelect,
                    picked !== null && styles.matchSelectFilled
                  )}
                  aria-label="Elige el par"
                >
                  <option value="">— elige —</option>
                  {draft.rightOrder.map((rightPairIdx, rightSlot) => (
                    <option key={rightSlot} value={rightSlot}>
                      {question.pairs[rightPairIdx].match}
                    </option>
                  ))}
                </select>
                {showFeedback && correct && <Check size={16} className={styles.matchIcon} />}
                {showFeedback && wrong && <X size={16} className={styles.matchIcon} />}
              </div>
            </li>
          );
        })}
      </ol>

      {showFeedback && (
        <div className={styles.correctAnswers}>
          <span className={styles.correctAnswersLabel}>Pares correctos</span>
          <ul className={styles.correctPairs}>
            {question.pairs.map((p, i) => (
              <li key={i}>
                <strong>{p.item}</strong> → {p.match}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
